export default () => ({
  isActive: false,
  isShow: false,
  isShowPrice: false,
  covenants: [],
  graduations: {},
  professionalProfilePublic: [],
  crm: null,
  uf: null,
  professionalQRCodeURL: null,
  profilePublic: [],
  totalAgendas: null,
  totalAgendaSchedules: null,
  totalProfessional: null,
  operatorCovenant: null,
  noProfilePublic: false,
  loading: false,
  text: 'Aguarde Processando...',
  dark: false,
  classes: null,
  background: null,
  customLoader: null
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/gadget/resources/data.js